const parseJSON = (str) => {
  try {
    return JSON.parse(str);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Failed to parse rich text metafield:', e);
    return null;
  }
}
export default parseJSON;
